export const PTProgressSpinner = {
  root: {
    className: 'ax-progress-loader',
  },
  spinner: {
    className: 'ax-progress-loader-svg',
  },
  circle: {
    className: 'ax-progress-loader-circle',
  },
};
